import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Chip from '@material-ui/core/Chip'
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    //justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
      padding: theme.spacing(0.15),
    },
  },
  round: {
    borderRadius: '10px',
  },
}))
export default function StatusButton(props) {
  const classes = useStyles()
  const { color } = props
  return (
    <div className={classes.root}>
      <Chip
        avatar={
          <div
            className={`${classes[props.color]} ${classes.round}`}
            style={{ background: color }}
          ></div>
        }
        label={props.text}
        size="small"
        variant="outlined"
      />
    </div>
  )
}
